// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__9KtRB","assignButton":"CreateEditEquipmentSchedule_assignButton__1Jyzm"};